import { injectGlobal } from 'styled-components'

const pink = '#E9A2B8'
const grey = '#999'

export const typography = {
  serif: 'font-family: Libre Baskerville, Baskerville, serif;',
  pink: `color: ${pink};`,
  grey: `color: ${grey};`
}

export function injectGlobalStyles () {
  return injectGlobal`
    body {
      margin: 0;
      padding: 0;
      color: #fff;
      ${typography.serif}
      box-sizing: border-box;
      overflow: hidden;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    *,
    *::before,
    *::after {
      box-sizing: inherit;
    }
    h1, h2, h3, h4, h5, h6, p {
      font-size: inherit;
      margin: 0;
    }
    .Text {
      font-weight: bold;
      font-size: 0.75rem;
    }
    .Text.Text--Pink {
      color: ${pink};
    }
    .Text.Text--Grey {
      color: ${grey};
    }
    @keyframes fade-in {
      0% { opacity: 0; }
      100% { opacity: 1; }
    }
    @keyframes to-foreground {
      0% { opacity: 1; transform: scale(1); }
      100% { opacity: 0; transform: scale(1.2); }
    }
    @keyframes from-foreground {
      0% { opacity: 0; transform: scale(1.2); }
      100% { opacity: 1; transform: scale(1); }
    }
    @keyframes to-background {
      0% { opacity: 1;  transform: scale(1); }
      100% { opacity: 0; transform: scale(0.8); }
    }
    @keyframes from-background {
      0% { opacity: 0; transform: scale(0.8); }
      100% { opacity: 1; transform: scale(1); }
    }
  `
}



/** WEBPACK FOOTER **
 ** ./src/styles.js
 **/